import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { LoginServico } from "../servicos/login.servico";
import { UtilServico } from "../servicos/util.servico";
import { Router, ActivatedRoute } from "@angular/router";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { DatePipe, registerLocaleData } from "@angular/common";
import { NativeDateAdapter, NativeDateModule } from "@angular/material";
import { CurrencyMaskModule } from "ngx-currency-mask";
import {
  CurrencyMaskConfig,
  CURRENCY_MASK_CONFIG,
} from "ngx-currency-mask/src/currency-mask.config";
import {
  FormControl,
  FormsModule,
  NgForm,
  FormBuilder,
  FormGroup,
  Validators,
  FormGroupDirective,
} from "@angular/forms";
import {
  ErrorStateMatcher,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  DateAdapter,
} from "@angular/material/core";
import { ResponseContentType } from "@angular/http";
import { saveAs } from "file-saver/FileSaver";
import { UtilDadosLogado } from "../servicos/util.logado";
import swal from "sweetalert2";
import localePt from "@angular/common/locales/pt";
import { DataSource } from "@angular/cdk/collections";

import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import { resolve } from "url";
import { Observable, ReplaySubject } from "rxjs";
import { map } from "rxjs/operators";
// import { setInterval } from 'timers';

registerLocaleData(localePt);

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  allowZero: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: ".",
};

interface CustomFile {
  name: string;
  fullName: string;
  file: File;
  source: String | ArrayBuffer;
  angle: number;
  rotatedFile: File;
}

let ELEMENT_DATA: CustomFile[] = [];

class ExampleDataSource extends DataSource<CustomFile> {
  private _dataStream = new ReplaySubject<CustomFile[]>();

  constructor(initialData: CustomFile[]) {
    super();
    this.setData(initialData);
  }

  connect(): Observable<CustomFile[]> {
    return this._dataStream;
  }

  disconnect() { }

  setData(data: CustomFile[]) {
    this._dataStream.next(data);
  }
}
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

export function matchValidator(fieldName: string) {
  let fcfirst: FormControl;
  let fcSecond: FormControl;

  return function matchValidator(control: FormControl) {
    if (!control.parent) {
      return null;
    }

    // INITIALIZING THE VALIDATOR.
    if (!fcfirst) {
      //INITIALIZING FormControl first
      fcfirst = control;
      fcSecond = control.parent.get(fieldName) as FormControl;

      //FormControl Second
      if (!fcSecond) {
        throw new Error(
          "matchValidator(): Second control is not found in the parent group!"
        );
      }

      fcSecond.valueChanges.subscribe(() => {
        fcfirst.updateValueAndValidity();
      });
    }

    if (!fcSecond) {
      return null;
    }

    if (fcSecond.value !== fcfirst.value) {
      return {
        matchOther: true,
      };
    }

    return null;
  };
}
const MOMENT_FORMATS = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM-YYYY",
  },
};

export class InformPortal {
  INFORME_ID: number;
  USR_LOGIN_ID: number;
  DATA_VISUALIZACAO: string;
}
export class MyDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === "input") {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } else {
      return date.toDateString();
    }
  }
}
//declare var swal: any;
declare var jquery: any;
declare var $: any;
@Component({
  selector: "app-inicial",
  templateUrl: "./inicial.component.html",
  styleUrls: ["./inicial.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: MyDateAdapter },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_FORMATS },
  ],
})
export class InicialComponent implements OnInit {
  notificationCount: number = 0;
  userForm: FormGroup;
  password = "password";
  display = "none";
  letCampo: boolean = false;
  //configuracoes: any;
  pesquisar: any;
  Placar: any;
  DADOS: any;
  DADOS2: any;
  SENHA: any;
  TotalRegistro: number;
  PaginaAtual: number = 1;
  PaginaTotal: number = 25;
  Mostrar: any;
  MostrarFichaFinanceira: any;
  DADOSSIMULACAO: any;
  DADOSSIMULACAOESPONTANEA: any;
  DADOSPESSOAIS: any;
  DADOSRENDIMENTOS: any;
  EXPLICACAOREGRA: any;
  EXPLICACAOREGRAEXPONTANEA: any;
  ABONO_PERMANENCIA: any;
  DADOS_CEDENTE_BOLETO: any;
  public DADOCONTRIB: any;
  public DADOHOLERITE: any;
  public DADOSFICHA: any;
  public parametros: any;
  confirmedFileToUpload: File | null = null;
  fileToUploadName: any;
  confirmedFileToUploadName: any;

  //public sub = "http://localhost:62195/api/Inicial/";
  //public sub = "http://localhost/webapiportales/api/Inicial/";
  //public sub = "http://proxima.sisprevweb.com.br/webapiportales/api/Inicial/";
  //public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipe/api/Inicial/";
  // public sub = "http://sisprev.sergipeprevidencia.se.gov.br/webapiportalsergipehomologacao/api/Inicial/";
  uf = [];
  cidades = [];
  cidadesEleicao = [];
  erroCodigoValidacao: boolean = false;
  estadoCivil = [];
  segurados = [];
  nacionalidade = [];
  @ViewChild("myInput") myInputVariable;
  raca = [];
  FALE: any;
  assunto = [];
  BOLETOS_PORTAL = [];
  SOLIC_BENEF: any;
  assuntoSolicitacaoBenef = [];
  selectedAssuntoSolicitacaoBenefId: any;
  selectedAssuntoSolicitacaoBenef: any;
  parametroPortalCategoria = [];

  public eleicoes = [];
  public eleicoesComComprovante = [];
  public candidatos = [];
  public eleicaoId: number;
  candidatoselecionado: Number;
  confirmarvoto: boolean;
  fotoid: Number;
  Nomecandidato: string;

  displayedColumns: string[] = ["delete", "edit", "fullName", "name"];
  dataToDisplay = [...ELEMENT_DATA];
  file: File;
  fileName: string;
  dataSource = new ExampleDataSource(this.dataToDisplay);
  editMode: boolean = false;
  fileToUpload: File | null = null;

  public sexo: Array<Object> = [
    { ID: "M", NOME: "Masculino" },
    { ID: "F", NOME: "Feminino" },
  ];
  public estadocivil: Array<Object> = [
    { ID: 1, NOME: "SOLTEIRO(A)" },
    { ID: 2, NOME: "CASADO(A)" },
    { ID: 3, NOME: "VIÚVO(A)" },
    { ID: 4, NOME: "SEPARADO(A) JUDICIALMENTE" },
    { ID: 5, NOME: "DIVORCIADO(A)" },
    { ID: 6, NOME: "UNIÃO ESTÁVEL" },
    { ID: 9, NOME: "OUTROS(A)" },
  ];
  public apos: Array<Object> = [
    { ID: "S", NOME: "Sim - Professor" },
    { ID: "N", NOME: "Não" },
  ];
  public mes: Array<Object> = [
    { ID: 1, NOME: "Janeiro" },
    { ID: 2, NOME: "Fevereiro" },
    { ID: 3, NOME: "Março" },
    { ID: 4, NOME: "Abril" },
    { ID: 5, NOME: "Maio" },
    { ID: 6, NOME: "Junho" },
    { ID: 7, NOME: "Julho" },
    { ID: 8, NOME: "Agosto" },
    { ID: 9, NOME: "Setembro" },
    { ID: 10, NOME: "Outubro" },
    { ID: 11, NOME: "Novembro" },
    { ID: 12, NOME: "Dezembro" },
  ];
  public logradouro: Array<Object> = [
    { ID: 8, NOME: "Avenida" },
    { ID: 81, NOME: "Rua" },
    { ID: 100, NOME: "Travessa" },
    { ID: 77, NOME: "Quadra" },
    { ID: 65, NOME: "Praça" },
    { ID: 104, NOME: "Vila" },
    { ID: 4, NOME: "Alameda" },
    { ID: 31, NOME: "Estrada" },
    { ID: 90, NOME: "Rodovia" },
    { ID: 105, NOME: "Assentamento" },
    { ID: 106, NOME: "Condomínio" },
    { ID: 107, NOME: "Conjunto" },
    { ID: 108, NOME: "Distrito" },
    { ID: 109, NOME: "Fazenda" },
    { ID: 110, NOME: "Jardim" },
    { ID: 111, NOME: "Loteamento" },
    { ID: 112, NOME: "Parque" },
    { ID: 113, NOME: "Povoado" },
    { ID: 114, NOME: "Sítio" },
  ];
  selectedAssunto: any;
  selectedAssuntoId: any;
  isValidarCC: any;
  isValidarRedimento: any;
  isValidaNotificacao: any;
  public resultados = [];
  FormControl = new FormControl("", [Validators.required, Validators.email]);

  matcher = new MyErrorStateMatcher();

  informativos = [];
  perguntasFrequentes = [];

  recadastramentoOnline = [];
  recadastramentoOnlineData: any;
  agendDataIni: any;
  agendDataFim: any;
  agendDescricao: any;
  dependentes = [];
  recadastramentoOnlineExibir = false;

  constructor(
    private fBuilder: FormBuilder,
    private http: Http,
    private LoginServico: LoginServico,
    private UtilServico: UtilServico,
    private router: Router,
    private datePipe: DatePipe,
    private dateAdapter: DateAdapter<MyDateAdapter>,
    private formBuilder: FormBuilder,
    public UtilDadosLogado: UtilDadosLogado
  ) {
    this.dateAdapter.setLocale("ptb");
  }

  public CountNotification() {
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/GetNotificarInformativos",
        JSON.stringify({
          USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
        }),
        options
      )
      .map((response: Response) => response.json())
      .subscribe(
        (data) => {
          this.notificationCount = data;
        },
        (error) => {
          this.Mostrar = false;
        }
      );
  }

  ngOnInit() {
    this.UtilDadosLogado.DadosAcesso().DATA_ULTIMO_ACESSO =
      this.datePipe.transform(
        this.UtilDadosLogado.DadosAcesso().DATA_ULTIMO_ACESSO,
        "dd/MM/yyyy HH:mm:ss"
      );
    this.pesquisar = {
      PesquisarPor: 1,
      CadastroInLoco: "T",
      Concluido: "T",
      Categoria: 1,
    };
    this.DADOS = {};
    this.DADOS2 = {};
    this.DADOSSIMULACAO = { Codigo: 0 };
    this.DADOSSIMULACAOESPONTANEA = { Codigo: 0 };
    this.DADOCONTRIB = {
      MES_INICIO: new Date().getMonth() + 1,
      ANO_INICIO: new Date().getFullYear(),
      MES_FIM: new Date().getMonth() + 1,
      ANO_FIM: new Date().getFullYear(),
    };
    this.SENHA = {};
    this.FALE = {};
    this.SOLIC_BENEF = {
      DATA_ABERT: this.datePipe.transform(new Date(), "dd/MM/yyyy"),
      ASSUNTO_ID: "",
      DSC: "",
    };
    this.EXPLICACAOREGRA = {};
    this.DADOSPESSOAIS = {};
    this.parametros = {};
    this.DADOHOLERITE = {
      MES: new Date().getMonth() + 1,
      ANO: new Date().getFullYear(),
    };
    this.DADOSFICHA = { ANO: new Date().getFullYear() };
    this.DADOSRENDIMENTOS = { ANO: new Date().getFullYear() - 1 };
    this.GetSegurados();
    this.GetParametros();
    this.GetEleicoes();
    this.GetEleicoesComComprovante();
    this.Assunto();
    this.RecadastramentoOnline();
    this.AssuntoSolicitarBeneficio();

    this.GetParametroCategoriaSegurado();
  }

  GetParametroCategoriaSegurado(): void {
    this.UtilServico.Get("GetParametroSisCategoriaPortal?categoria=" + encodeURIComponent(this.UtilDadosLogado.DadosAcesso().CATEGORIA) +
      "&categoriaId=" + this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID + "&seguradoId=" + this.UtilDadosLogado.DadosAcesso().SEGURADO_ID +
      "&usrLoginId=" + this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID
    ).subscribe(
        (data: any[]) => {
          this.parametroPortalCategoria = data[0];
      },
      (error) => {
        
      }
    );
  }

  //#region parametronotificacoes
  ValidarNotificacao(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.UtilServico.Post(
        "ValidarNotificacao",
        JSON.stringify({
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        })
      ).subscribe(
        (result) => {
          this.isValidaNotificacao = result;

          resolve(true);
        },
        (error) => {
          reject(false);
        }
      );
    });
  }

  ValidarNotificacaoCC(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.UtilServico.Post(
        "ValidarNotificacaoCC",
        JSON.stringify({
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        })
      ).subscribe(
        (result) => {
          this.isValidarCC = result;
          resolve(true);
        },
        (error) => {
          reject(false);
        }
      );
    });
  }

  ValidarNotificacaoRendimento(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.UtilServico.Post(
        "ValidarNotificacaoRendimento",
        JSON.stringify({
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        })
      ).subscribe(
        (result) => {
          this.isValidarRedimento = result;
          resolve(true);
        },
        (error) => {
          reject(false);
        }
      );
    });
  }

  CarregarGridInicial(currentPage: number) {
    this.Mostrar = true;

    this.UtilServico.Post(
      "GetProcesso",
      JSON.stringify({
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
        SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.TotalRegistro = data.Total;
        this.resultados = data.Resultado;
        console.log(this.resultados);
        if (this.TotalRegistro == 0) {
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum processo encontrado",
          });
        }
      },
      (error) => { }
    );
  }

  public pageChanged(event: any): void {
    this.PaginaAtual = event;
    this.CarregarGridInicial(event);
  }

  public EditarClick() {
    this.CarregarGridInicial(1);
  }

  removeData(element: CustomFile) {
    if (confirm("Deseja realmente Excluir este arquivo?")) {
      this.dataToDisplay = this.dataToDisplay.filter((x) => x != element);

      this.dataSource.setData(this.dataToDisplay);

      ELEMENT_DATA = this.dataToDisplay;
    }
  }
  handleFileInput(files: FileList) {
    var ext = files.item(0).name.match(/\.([^\.]+)$/)[1];

    switch (ext.toLowerCase()) {
      case "gif":
      case "jpg":
      case "jpeg":
      case "pdf":
      case "doc":
      case "docx":
      case "xls":
      case "xlsx":
      case "rar":
      case "png":
        if (files.item(0).size / 1024 / 1024 <= 4) {
          this.fileToUpload = files.item(0);
        } else {
          this.fecharAnexoDoc();

          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "O arquivo ultrapassou o limite de tamanho de 4 megas.",
          });
        }

        break;
      default:
        this.fecharAnexoDoc();

        swal.fire({
          title: "Atenção!",
          type: "error",
          text: "A extensão " + ext + " não é suportada!",
        });

        this.myInputVariable.nativeElement.value = "";

        break;
    }
  }
  confirmUpload() {
    if (this.fileToUpload != null) {
      if (this.fileToUploadName) {
        this.confirmedFileToUpload = this.fileToUpload;
        this.confirmedFileToUploadName = this.fileToUploadName;
        this.fileToUploadName = null;
        this.fileToUpload = null;
        this.myInputVariable.nativeElement.value = "";
        this.fecharAnexoDoc();
      } else {
        swal.fire({
          title: "Atenção!",
          type: "error",
          text: "É obrigatório preencher o nome do arquivo!",
        });
        this.fileToUpload = null;
        this.myInputVariable.nativeElement.value = "";
      }
    } else {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "É obrigatório anexar um arquivo!",
      });
      this.fileToUpload = null;
      this.myInputVariable.nativeElement.value = "";
    }

    this.fecharAnexoDoc();
  }
  public fecharAnexoDoc() {
    $("#ModalAnexarDoc").hide();
    $("#ModalDadosPessoais").show();
    this.fileToUploadName = "";
  }
  public EnviarArquivosTMP(self, data): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      let formData: any;
      let promises: any = [];

      for (let index = 0; index < self.dataToDisplay.length; index++) {
        formData = new FormData();

        formData.append("oFile", self.dataToDisplay[index].rotatedFile);
        formData.append("oFileName", self.dataToDisplay[index].name);
        formData.append("oFileFullName", self.dataToDisplay[index].fullName);
        formData.append("oPessoaId", self.DADOSPESSOAIS.PESSOA_ID);
        formData.append("oUserId", self.DADOSPESSOAIS.USR_LOGIN_ID);
        formData.append("oPessoaTmpId", data);
        formData.append("oIndex", (index + 1).toString());

        promises.push(self.EnviarArquivoTMP(self, formData));
      }

      Promise.all(promises)
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          reject(false);
        });
    });
  }

  public EnviarArquivoTMP(self, formData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      self.http
        .put(
          self.UtilDadosLogado.DadosAcesso().URL +
          "/api/Inicial/PutArquivosPessoasTmp",
          formData
        )
        .pipe(map((res: Response) => res.json()))
        .subscribe(
          (data) => {
            resolve(true);
          },
          (error) => {
            reject(false);
          }
        );
    });
  }

  public EnviarArquivos(self): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      let formData: any;
      let promises: any = [];

      for (let index = 0; index < self.dataToDisplay.length; index++) {
        formData = new FormData();

        formData.append("oFile", self.dataToDisplay[index].rotatedFile);
        formData.append("oFileName", self.dataToDisplay[index].name);
        formData.append("oFileFullName", self.dataToDisplay[index].fullName);
        formData.append("oPessoaId", self.DADOSPESSOAIS.PESSOA_ID);
        formData.append("oUserId", self.DADOSPESSOAIS.USR_LOGIN_ID);
        formData.append(
          "oIndex",
          (self.DADOSPESSOAIS.MAX_ORDER + (index + 1)).toString()
        );

        promises.push(self.EnviarArquivo(self, formData));
      }

      Promise.all(promises)
        .then(() => {
          resolve(true);
        })
        .catch(() => {
          reject(false);
        });
    });
  }

  public EnviarArquivo(self, formData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      self.http
        .put(
          self.UtilDadosLogado.DadosAcesso().URL +
          "/api/Inicial/PutArquivosPessoas",
          formData
        )
        .pipe(map((res: Response) => res.json()))
        .subscribe(
          (data) => {
            resolve(true);
          },
          (error) => {
            reject(false);
          }
        );
    });
  }

  //#region simulacao
  public Simulacao() {
    this.DADOS2.DATA_CALC = this.datePipe.transform(new Date(), "dd/MM/yyyy");
    this.Mostrar = true;
    this.DADOSSIMULACAO.Codigo = 0;
    this.UtilServico.Post(
      "GetSimulacao",
      JSON.stringify({
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
        SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
        CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        DATA_CALC: this.DADOS2.DATA_CALC,
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.TotalRegistro = data.Total;
        this.DADOS2 = data.Resultado[0];
        this.DADOS = this.DADOS2.Table[0];
        this.DADOS2.DATA_CALC = this.datePipe.transform(
          new Date(),
          "dd/MM/yyyy"
        );
        this.DADOS.DATA_ADM = this.datePipe.transform(
          this.DADOS.DATA_ADM,
          "dd/MM/yyyy"
        );
        this.DADOS.DATA_NASC = this.datePipe.transform(
          this.DADOS.DATA_NASC,
          "dd/MM/yyyy"
        );
      },
      (error) => { }
    );
  }

  public async SimularSegurado(event: any) {
    this.ABONO_PERMANENCIA = "N";
    this.Mostrar = true;

    try {
      const payload = {
        USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
        SEGURADO_ID: event,
        DATA_CALC: this.DADOS2.DATA_CALC,
        DATA_NASC: this.DADOS.DATA_NASC,
        IDADE: this.DADOS.IDADE,
        ABONO_PERMANENCIA: "N",
      };

      const data: any = await this.UtilServico.Post(
        "SimularSegurado",
        JSON.stringify(payload)
      ).toPromise(); //

      this.DADOSSIMULACAO = data;
      this.Mostrar = false;
      if (data.Codigo === 0) {
        await swal.fire({
          title: "Atenção!",
          type: "error",
          text: data.Msg,
        });
      } else {
        this.DADOSSIMULACAO.Codigo = 1;
        this.TotalRegistro = data.Total;
        this.resultados = data.Resultado;
      }
    } catch (error) {
      console.error("Erro na requisição:", error);
      await swal.fire({
        title: "Erro!",
        type: "error",
        text: "Ocorreu um erro ao processar a simulação.",
      });
    } finally {
      this.Mostrar = false;
    }
  }

  public async ResultadoSimulacao(event: any) {
    this.Mostrar = true;

    const headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });

    const options = new RequestOptions({
      headers: headers,
      responseType: ResponseContentType.Blob,
    });

    try {
      const response: any = await this.http
        .post(
          this.UtilDadosLogado.DadosAcesso().URL +
          "/api/Inicial/GetResultadoSimulacao",
          JSON.stringify({
            RESULTADO_SIMULACAO_ID: event.RESULTADO_SIMULACAO_ID,
            SIMULA_REQUISITO_ID: event.SIMULA_REQUISITO_ID,
            TmpCarreira: event.TmpCarreira,
            SIMULA_ABONO: this.ABONO_PERMANENCIA,
          }),
          options
        )
        .toPromise();

      const blob = new Blob([response._body], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      await swal.fire({
        title: "Erro",
        text: "Erro ao gerar o resultado da simulação.",
        type: "error",
      });
    } finally {
      this.Mostrar = false;
    }
  }

  public ExplicacaoRegra(event: any) {
    this.EXPLICACAOREGRA = event;
    $("#ModalSimulacaoExplicao").show();
    $("#ModalSimulacao").hide();
  }
  public SairExplicacaoRegra() {
    $("#ModalSimulacaoExplicao").hide();
    $("#ModalSimulacao").show();
  }
  public SimularSeguradoAbono(event: any) {
    this.ABONO_PERMANENCIA = "S";
    this.Mostrar = true;
    this.UtilServico.Post(
      "SimularSegurado",
      JSON.stringify({
        SEGURADO_ID: event,
        DATA_CALC: this.DADOS2.DATA_CALC,
        DATA_NASC: this.DADOS.DATA_NASC,
        IDADE: this.DADOS.IDADE,
        ABONO_PERMANENCIA: "S",
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.DADOSSIMULACAO = data;
        if (data.Codigo == 0) {
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: data.Msg,
          });
        } else {
          this.DADOSSIMULACAO.Codigo = 1;
          this.TotalRegistro = data.Total;
          this.resultados = data.Resultado;
        }
      },
      (error) => { }
    );
  }
  //#endregion simulacao

  //#region simulacaoespontanea
  public ExplicacaoRegraExpontanea(event: any) {
    this.EXPLICACAOREGRAEXPONTANEA = event;
    $("#ModalSimulacaoExplicaoExpontanea").show();
    $("#ModalSimulacaoEspontanea").hide();
  }
  public SairExplicacaoRegraExpontanea() {
    $("#ModalSimulacaoExplicaoExpontanea").hide();
    $("#ModalSimulacaoEspontanea").show();
  }
  public SimulacaoEspontanea() {
    this.DADOSSIMULACAOESPONTANEA.Codigo = 0;
    this.Mostrar = true;
    this.UtilServico.Post(
      "GetSimulacaoEspontanea",
      JSON.stringify({
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
        SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
        CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        DATA_CALC: this.DADOS2.DATA_CALC,
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.TotalRegistro = data.Total;
        this.DADOS2 = data.Resultado[0];
        this.DADOS = this.DADOS2.Table[0];
        this.DADOS.DATA_ADM = this.datePipe.transform(
          this.DADOS.DATA_ADM,
          "dd/MM/yyyy"
        );
        this.DADOS.DATA_NASC = this.datePipe.transform(
          this.DADOS.DATA_NASC,
          "dd/MM/yyyy"
        );
        this.DADOS.ESPECIAL = "N";
        this.DADOS2.DATA_CALC = this.datePipe.transform(
          new Date(),
          "dd/MM/yyyy"
        );
        this.DADOS.DATA_CALC = this.DADOS2.DATA_CALC;
      },
      (error) => { }
    );
  }
  public SimularEspontanea(event: any) {
    this.Mostrar = true;
    this.DADOSSIMULACAOESPONTANEA.Codigo = 0;
    this.UtilServico.Post(
      "GetGerarSimulacaoEspontanea",
      JSON.stringify({
        USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
        SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
        CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        DATA_CALC: this.DADOS2.DATA_CALC,
        DATA_ADM: this.DADOS.DATA_ADM,
        ESPECIAL: this.DADOS.ESPECIAL,
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.DADOSSIMULACAOESPONTANEA = data;
        if (data.Codigo == 0) {
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: data.Msg,
          });
        } else {
          this.DADOSSIMULACAOESPONTANEA.Codigo = 1;
          this.TotalRegistro = data.Total;
          this.resultados = data.Resultado;
        }
      },
      (error) => {
        this.Mostrar = false;
      }
    );
  }

  //#endregion simulacaoespontanea

  public Processos(event: any) {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetHistorico",
        JSON.stringify({ NrProcesso: event }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "HistoricoProcesso.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }

  public SolicitacaoTempoContribuicao(event: any) {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetSolicitacaoTempoContribuicao",
        JSON.stringify({ NrProcesso: event }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;

          var file = new Blob([data], { type: 'application/zip' });

          saveAs(file, "ctc.zip");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum arquivo encontrado!",
          });
        }
      );
  }

  isSolicitacaoCTC(descricao: string): boolean {
    if (!descricao) {
      return false;
    }

    const texto = descricao.toUpperCase();

    return texto.includes('SOLICITAÇÃO DE CERTIDÃO TEMPO DE CONTRIBUIÇÃO') ||
          texto.includes('CERTIDÃO DE TEMPO DE CONTRIBUIÇÃO');
  }

  AlterSenha() {
    this.Mostrar = true;
    if (this.SENHA.NOVA !== this.SENHA.CONFIRMA) {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "A nova senha não confere com o conteúdo digitado em Confirma Senha!",
      });
    } else {
      this.UtilServico.Post(
        "GetTrocarSenha",
        JSON.stringify({
          ATUAL: this.SENHA.ATUAL,
          NOVA: this.SENHA.NOVA,
          LOGIN: this.UtilDadosLogado.DadosAcesso().LOGIN,
          USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
        })
      ).subscribe(
        (data) => {
          this.Mostrar = false;
          this.TotalRegistro = data.Total;
          if (this.TotalRegistro == 0) {
            swal.fire({
              title: "Atenção!",
              type: "error",
              text: "Senha atual não confere!",
            });
          } else {
            swal.fire({
              title: "Atenção!",
              type: "success",
              text: "Senha alterada com sucesso!",
            });
            $("#ModalTrocarSenha").hide();
            $(document.body).removeClass("modal-open");
            $(".modal-backdrop").remove();
          }
        },
        (error) => {
          this.Mostrar = false;
        }
      );
    }
  }

  //#region faleconosco
  Assunto() {
    if (this.UtilDadosLogado.DadosAcesso().FONE_RESIDENCIAL != null)
      this.FALE.FONE_RESIDENCIAL =
        this.UtilDadosLogado.DadosAcesso().FONE_RESIDENCIAL;
    if (this.UtilDadosLogado.DadosAcesso().EMAIL1 != null)
      this.FALE.EMAIL1 = this.UtilDadosLogado.DadosAcesso().EMAIL1;
    this.UtilServico.Get("GetAssunto").subscribe(
      (data) => (this.assunto = data),
      (error) => { }
    );
  }
  setAssunto($event) {
    this.selectedAssuntoId = $event;
    for (var i = 0; i < this.assunto.length; i++) {
      if (this.assunto[i].ASSUNTO_ID == $event) {
        this.selectedAssunto = this.assunto[i].NOME;
      }
    }
  }

  FaleConosco() {
    this.Mostrar = true;
    this.UtilServico.Post(
      "GetFaleConosco",
      JSON.stringify({
        ASSUNTO_ID: this.selectedAssuntoId,
        ASSUNTO_NOME: this.selectedAssunto,
        EMAIL1: this.FALE.EMAIL1,
        FONE_RESIDENCIAL: this.FALE.FONE_RESIDENCIAL,
        DSC_ASSUNTO: this.FALE.DSC_ASSUNTO,
        NOME: this.UtilDadosLogado.DadosAcesso().NOME,
        USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
        SEXO: this.UtilDadosLogado.DadosAcesso().SEXO,
      })
    ).subscribe(
      (data) => {
        this.TotalRegistro = data.Total;
        this.Mostrar = false;
        swal.fire({
          title: "Atenção!",
          type: "success",
          text: "Email encaminhado com sucesso!",
        });
      },
      (error) => {
        this.Mostrar = false;
        swal.fire({
          title: "Atenção!",
          type: "error",
          text: "Favor verificar se os parâmetros estão preenchidos corretamente!",
        });
      }
    );
  }
  //#endregion faleconosco

  //#region dadospessoais
  GetUf() {
    this.UtilServico.Get("GetUf").subscribe(
      (data) => {
        this.uf = data;
      },
      (error) => { }
    );
  }

  GetCidades() {
    this.UtilServico.Get(
      "GetCidades/" + this.DADOSPESSOAIS.UF_NASCIMENTO
    ).subscribe(
      (data) => {
        this.cidades = data;
      },
      (error) => { }
    );
  }

  GetCidadesEleicao(event) {
    const naturalidade = this.formConfirmacaoDadosEleicao.get("naturalidade");
    if (!naturalidade) return false;

    naturalidade.setValue(null);

    this.UtilServico.Get(
      "GetCidades/" + event.value
    ).subscribe(
      (data) => {
        this.cidadesEleicao = data;
      },
      (error) => { }
    );
  }

  GetEstadoCivil() {
    this.UtilServico.Get(
      "GetEstadoCivil"
    ).subscribe(
      (data) => {
        this.estadoCivil = data;
      },
      (error) => { }
    );
  }

GetSegurados() {
  this.UtilServico.Get(
    "GetSegurados/" + this.UtilDadosLogado.DadosAcesso().PESSOA_ID
  ).subscribe(
    (data: any) => {
      this.segurados = data;

      if (this.segurados.length > 0) {
        const primeiro = this.segurados[0].SEGURADO_ID;

        this.UtilDadosLogado.DadosAcesso().SEGURADO_ID = primeiro;

        this.GetSeguradoInfo(primeiro);
      }
    },
    (error) => {}
  );
}

  EmitirProtocoloRecadastramento() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/ImprimirProtocolo",
        JSON.stringify({
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          if (window.navigator.msSaveOrOpenBlob) {
            //IE & Edge
            //msSaveBlob only available for IE & Edge
            saveAs(file, "ProtocoloRecadastramento.pdf");
          } else {
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }

          //saveAs(file, "ComprovanteRendimentosPagos.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }
  GetSeguradoInfo(event) {
    this.Mostrar = true;
    
    this.UtilServico.Get("GetSeguradoInfo/" + event).subscribe(
      (data) => {
        localStorage.setItem(
          "AcessoAdm",
          JSON.stringify(
            Object.assign(data, { URL: this.UtilDadosLogado.DadosAcesso().URL, TOKEN: this.UtilDadosLogado.DadosAcesso().TOKEN })
          )
        );
        this.GetParametros();
        this.Mostrar = false;
      },
      (error) => {
        this.Mostrar = false;
      }
    );
    if (this.parametros.PORTAL_OCULTA_OPCAO_FOLHA_PROCESSADA_VAZIA == "S") {
      this.GetInfFinanceiraSegurado(event);
    }
  }
  GetInfFinanceiraSegurado(event) {
    this.Mostrar = true;
    this.UtilServico.Get("GetInfFinanceiraSegurado/" + event).subscribe(
      (data) => {
        this.parametros.PORTAL_HOLERITE_CONTRACHEQUE = data;
        this.parametros.PORTAL_FICHA_FINANCEIRA = data;
        this.parametros.PORTAL_CRP = data == true ? "S" : "N";
        this.Mostrar = false;
      },
      (error) => {
        this.Mostrar = false;
      }
    );
  }
  upload() { }
  GetNacionalidade() {
    this.UtilServico.Get("GetNacionalidade").subscribe(
      (data) => {
        this.nacionalidade = data;
      },
      (error) => { }
    );
  }
  GetRaca() {
    this.UtilServico.Get("GetRaca").subscribe(
      (data) => {
        this.raca = data;
      },
      (error) => { }
    );
  }

  Pessoas() {
    this.GetUf();
    this.GetNacionalidade();
    this.GetRaca();
    this.Mostrar = true;
    this.UtilServico.Post(
      "GetPessoas",
      JSON.stringify({
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
      })
    ).subscribe(
      (data) => {
        this.Mostrar = false;
        this.DADOSPESSOAIS = data.Resultado;
        this.DADOSPESSOAIS.DATA_NASC = this.datePipe.transform(
          this.DADOSPESSOAIS.DATA_NASC,
          "dd/MM/yyyy"
        );
        this.DADOSPESSOAIS.RG_DT_EMISSAO = this.datePipe.transform(
          this.DADOSPESSOAIS.RG_DT_EMISSAO,
          "dd/MM/yyyy"
        );
        this.DADOSPESSOAIS.CTPS_DT_EMISSAO = this.datePipe.transform(
          this.DADOSPESSOAIS.CTPS_DT_EMISSAO,
          "dd/MM/yyyy"
        );
        this.DADOSPESSOAIS.UF_NASCIMENTO = data.UF;
        this.DADOSPESSOAIS.END_UF = data.END_UF;
        if (this.DADOSPESSOAIS.UF_NASCIMENTO != null) this.GetCidades();
        if (this.DADOSPESSOAIS.NACIONALIDADE_ID == null)
          this.DADOSPESSOAIS.NACIONALIDADE_ID = 25;
      },
      (error) => {
        this.Mostrar = false;
      }
    );
  }
  public SalvarPessoas() {
    this.Mostrar = true;
    let body = this.DADOSPESSOAIS;

    const formData: any = new FormData();

    $.each(this.dataToDisplay, function (i, file) {
      formData.append("oFile" + i, file.rotatedFile);
      formData.append("oFileName" + i, file.name);
      formData.append("oFileFullName" + i, file.fullName);
    });

    formData.append("oPessoaId", this.DADOSPESSOAIS.PESSOA_ID);
    formData.append("oUserId", this.DADOSPESSOAIS.USR_LOGIN_ID);

    if (this.parametros.PORTAL_CADASTRO_DIRETO === "S") {
      this.UtilServico.Put(
        "PutPESSOAS/" + this.DADOSPESSOAIS.PESSOA_ID,
        body
      ).subscribe(
        (data) => {
          this.http
            .put(
              this.UtilDadosLogado.DadosAcesso().URL +
              "/api/Inicial/PutArquivosPessoas",
              formData
            )
            .pipe(map((res: Response) => res.json()))
            .subscribe(
              (data) => {
                this.Mostrar = false;
                swal.fire({
                  title: "Atenção!",
                  type: "success",
                  text: "Cadastro atualizado com sucesso!",
                });
              },
              (error) => {
                this.Mostrar = false;
              }
            );
        },
        (error) => {
          this.Mostrar = false;
        }
      );
    } else {
      this.UtilServico.Put(
        "PutrPESSOAS_TMP/" + this.DADOSPESSOAIS.PESSOA_ID,
        body
      ).subscribe(
        (data) => {
          formData.append("oPessoaTmpId", data);
          this.http
            .put(
              this.UtilDadosLogado.DadosAcesso().URL +
              "/api/Inicial/PutArquivosPessoasTmp",
              formData
            )
            .pipe(map((res: Response) => res.json()))
            .subscribe(
              (data) => {
                this.Mostrar = false;
                swal.fire({
                  title: "Sucesso!",
                  type: "success",
                  text: "Solicitação enviada para análise!",
                });
              },
              (error) => {
                this.Mostrar = false;
              }
            );
        },
        (error) => {
          this.Mostrar = false;
        }
      );
    }
  }

  enableEditIndex = null;
  editableName: string = "";
  editableFullName: string = "";
  editableExt: string = "";
  mostrarImagens: boolean = false;
  urlImage: String | ArrayBuffer;

  trocaImagens() {
    this.mostrarImagens = !this.mostrarImagens;
  }

  ngDoCheck(): void {
    if (this.confirmedFileToUpload != null) {
      ELEMENT_DATA.push({
        name: this.confirmedFileToUpload.name,
        fullName: this.confirmedFileToUploadName,
        file: this.confirmedFileToUpload,
        source: "",
        angle: 0,
        rotatedFile: this.confirmedFileToUpload,
      });

      this.carregarImagem(ELEMENT_DATA, ELEMENT_DATA.length - 1);

      this.confirmedFileToUpload = null;

      this.confirmedFileToUploadName = null;

      this.dataToDisplay = [...ELEMENT_DATA];

      this.dataSource = new ExampleDataSource(this.dataToDisplay);
    }
  }

  carregarImagem(listOfFiles: CustomFile[], index: number) {
    var mimeType = listOfFiles[index].file.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(listOfFiles[index].file);
    reader.onload = (_event) => {
      listOfFiles[index].source = reader.result;
    };
  }

  enableEditMethod(element: CustomFile) {
    this.editableExt = "." + element.name.match(/\.([^\.]+)$/)[1];
    this.editableName = element.name.split(".").slice(0, -1).join(".");
    this.editableFullName = element.fullName;

    const index = this.dataToDisplay.indexOf(element);

    this.editMode = true;
    this.enableEditIndex = index;
  }

  addData() {
    const randomElementIndex = Math.floor(Math.random() * ELEMENT_DATA.length);
    this.dataToDisplay = [
      ...this.dataToDisplay,
      ELEMENT_DATA[randomElementIndex],
    ];
    this.dataSource.setData(this.dataToDisplay);
  }

  saveChanges(element: CustomFile) {
    if (this.editableName) {

      const index = this.dataToDisplay.indexOf(element);

      this.dataToDisplay[index].name = this.editableName + this.editableExt;
      this.dataToDisplay[index].fullName = this.editableFullName;

      this.editMode = false;
      this.enableEditIndex = null;
    } else {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "O preenchimento dos campos é obrigatório!",
      });
    }
  }

  girarImagemEsquerda(index: number) {
    const formData: any = new FormData();

    let angle = this.dataToDisplay[index].angle - 90;

    var alpha = angle;
    while (alpha < 0) {
      alpha += 360;
    }

    while (alpha > 360) {
      alpha -= 360;
    }

    this.dataToDisplay[index].angle = alpha;

    formData.append("oFile", this.dataToDisplay[index].file);
    formData.append("oAngle", this.dataToDisplay[index].angle);

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/RotateImage",
        formData,
        { responseType: ResponseContentType.Blob }
      )
      .pipe(map((res: Response) => res.json()))
      .subscribe(
        (data) => {
          this.Mostrar = false;

          var blob = new Blob([data], {
            type: this.dataToDisplay[index].file.type,
          });

          this.dataToDisplay[index].rotatedFile = new File(
            [blob],
            this.dataToDisplay[index].file.name,
            { type: this.dataToDisplay[index].file.type }
          );

          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = (_event) => {
            this.dataToDisplay[index].source = reader.result;
          };
        },
        (error) => {
          this.Mostrar = false;
        }
      );
  }

  downloadFile(element: CustomFile) {
    var reader = new FileReader();
    reader.readAsDataURL(element.rotatedFile);
    reader.onload = (_event) => {
      var file = new Blob([element.rotatedFile], { type: element.file.type });
      var fileURL = URL.createObjectURL(file);

      var width = window.innerWidth;
      var height = (width * window.innerHeight) / window.innerWidth;

      switch (element.file.name.match(/\.([^\.]+)$/)[1].toLowerCase()) {
        case "png":
        case "jpeg":
        case "jpg":
        case "gif":
        case "pdf":
          window.open(
            fileURL,
            "newwindow",
            "width=" + width + ",height=" + height
          );
          break;
        default:
          window.open(fileURL, "_blank");
      }
    };
  }

  girarImagemDireita(index: number) {
    const formData: any = new FormData();

    let angle = this.dataToDisplay[index].angle + 90;

    var alpha = angle;
    while (alpha < 0) {
      alpha += 360;
    }

    while (alpha > 360) {
      alpha -= 360;
    }

    this.dataToDisplay[index].angle = alpha;

    formData.append("oFile", this.dataToDisplay[index].file);
    formData.append("oAngle", this.dataToDisplay[index].angle);

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/RotateImage",
        formData,
        { responseType: ResponseContentType.Blob }
      )
      .pipe(map((res: Response) => res.json()))
      .subscribe(
        (data) => {
          this.Mostrar = false;

          var blob = new Blob([data], {
            type: this.dataToDisplay[index].file.type,
          });

          this.dataToDisplay[index].rotatedFile = new File(
            [blob],
            this.dataToDisplay[index].file.name,
            { type: this.dataToDisplay[index].file.type }
          );

          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = (_event) => {
            this.dataToDisplay[index].source = reader.result;
          };
        },
        (error) => {
          this.Mostrar = false;
        }
      );
  }

  moveUp(element: CustomFile): void {
    const index = this.dataToDisplay.indexOf(element);
    if (index === 0) {
      // can not move higher
      return;
    }
    const swap = this.dataToDisplay[index - 1];
    this.dataToDisplay[index - 1] = element;
    this.dataToDisplay[index] = swap;
    this.dataSource.setData(this.dataToDisplay);
    ELEMENT_DATA = this.dataToDisplay;
  }

  moveDown(element: CustomFile): void {
    const index = this.dataToDisplay.indexOf(element);
    if (index === this.dataToDisplay.length - 1) {
      // can not move higher
      return;
    }
    const swap = this.dataToDisplay[index + 1];
    this.dataToDisplay[index + 1] = element;
    this.dataToDisplay[index] = swap;
    this.dataSource.setData(this.dataToDisplay);
    ELEMENT_DATA = this.dataToDisplay;
  }

  public anexarDocumentos() {
    $("#ModalAnexarDoc").show();
    $("#ModalDadosPessoais").hide();
  }
  //#endregion dadospessoais

  //region extratocontrib
  public EmitirExtrato() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/GetExtratoContrib",
        JSON.stringify({
          MES_INICIO: this.DADOCONTRIB.MES_INICIO,
          ANO_INICIO: this.DADOCONTRIB.ANO_INICIO,
          MES_FIM: this.DADOCONTRIB.MES_FIM,
          ANO_FIM: this.DADOCONTRIB.ANO_FIM,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
          CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "ExtratoContribuicao.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }
  //#endregion extratocontrib

  //#region holerite
  public EmitirHolerite() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetHolerite",
        JSON.stringify({
          MES_INICIO: this.DADOHOLERITE.MES,
          ANO_INICIO: this.DADOHOLERITE.ANO,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          DECIMO: this.DADOHOLERITE.DECIMO,
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
          CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "Holerite.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }
  //#endregion holerite

  //#region fichafinanceira
  public EmitirFichaFinanceira() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/GetFichaFinanceira",
        JSON.stringify({
          ANO_INICIO: this.DADOSFICHA.ANO,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
          CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "FichaFinanceira.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }
  //#endregion fichafinanceira

  //region rendimentospagos
  public EmitirComprovanteRendimentos() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/ComprovanteRendimentos",
        JSON.stringify({
          ANO_INICIO: this.DADOSRENDIMENTOS.ANO,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
          CATEGORIA_ID: this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          //saveAs(file, "ComprovanteRendimentosPagos.pdf");
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }
  //#endregion rendimentospados

  private requiredIds: string[] = [];
  private eleicaoConfirmouDados: boolean = true;
  private eleicaoVerificouEmail: boolean = false;
  private formConfirmacaoDadosEleicao: FormGroup;
  private formVerificaEmail: FormGroup;
  private eleicaoFieldMap = {
    "0": 'nome',
    "1": 'cpf',
    "2": 'nomeMae',
    "3": 'dataNasc',
    "4": 'telefoneCelular',
    "5": 'estadoCivil',
    "6": 'ufNascimento',
    "7": 'naturalidade'
  };

  //regioneleicoes
  GetEleicoes(): void {
    this.GetEstadoCivil();
    this.GetUf();

    this.UtilServico.Get(
      "GetEleicoes?id=" + this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID + "&seguradoId=" + this.UtilDadosLogado.DadosAcesso().SEGURADO_ID
    ).subscribe(
      (data) => {
        this.eleicoes = data;

        if (data && data.length > 0) {
          this.eleicaoId = data[0].ENQUETE_PERGUNTA_ID;
          this.eleicaoConfirmouDados = !(data[0].CamposVerificacao && data[0].CamposVerificacao.length > 0) || data[0].ValidouDados == 1;
          this.eleicaoVerificouEmail = !data[0].CodigoAutenticacao || data[0].ValidouEmail == 1;

          this.inicializaEleicao();

          if (!this.eleicaoConfirmouDados) {
            const params = data[0].CamposVerificacao.split(',');

            let naturalidadeInvalida = params.includes("7") && !params.includes("6");

            if (naturalidadeInvalida)
              params.push("6");

            this.aplicaParametrosEleicao(params);
          } else if (!this.eleicaoVerificouEmail) {
            this.enviarCodigoEleicao(false).catch((error) => {
              swal.fire({ title: "Atenção!", type: "error", text: "Ocorreu erro durante a operação." });
            });
          }

          this.GetCandidatos();
        }
      },
      (error) => { }
    );
  }

  GetEleicoesComComprovante(): void {
    this.UtilServico.Get(
      "GetEleicoesComComprovante?userId=" + this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID
    ).subscribe(
      (data) => {
        this.eleicoesComComprovante = data;
      },
      (error) => { }
    );
  }

  public gerarComprovanteEleicao(eleicao: number = 0) {
    this.Mostrar = true;
    
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });

    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GerarComprovanteEleicao",
        JSON.stringify({
          userId: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
          pessoaId: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          eleicaoId: eleicao == 0 ? this.eleicaoId : eleicao
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;

          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);

          this.eleicaoId = null;

          window.open(fileURL);
        },
        (error) => {
          this.Mostrar = false;

          this.eleicaoId = null;

          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Ocorreu erro durante a geração do comprovante!",
          });
        }
      );
  }

  enviarCodigoEleicao(reenviar: boolean = false) {
    return new Promise((reject, resolve) => {
      this.UtilServico.Post(
        "EnviarCodigoEleicao",
        { userId: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID, pessoaId: this.UtilDadosLogado.DadosAcesso().PESSOA_ID, reenviar: reenviar }
      ).subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  validarCodigoEleicao(codigoEleicao: string) {
    return new Promise((resolve, reject) => {
      this.UtilServico.Post(
        "ValidarCodigoEleicao",
        { userId: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID, codigoEleicao: codigoEleicao, eleicaoId: this.eleicaoId }
      ).subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  verificaDadosEleicao() {
    if (!this.eleicaoConfirmouDados) {
      if (this.formConfirmacaoDadosEleicao.valid) {
        this.Mostrar = true;

        this.UtilServico.Post("VerificaDadosEleicao", { ...this.formConfirmacaoDadosEleicao.getRawValue(), pessoaId: this.UtilDadosLogado.DadosAcesso().PESSOA_ID, userId: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID, eleicaoId: this.eleicaoId }).subscribe(
          result => {
            if (result.Valido) {
              if (!this.eleicaoVerificouEmail) {
                this.enviarCodigoEleicao(false).then((result) => {
                  this.eleicaoConfirmouDados = true;
                  this.Mostrar = false;
                }).catch((error) => {
                  this.Mostrar = false;
                  swal.fire({ title: "Atenção!", type: "error", text: "Ocorreu erro durante a operação." });
                });
              }
              else {
                this.eleicaoConfirmouDados = true;
                this.Mostrar = false;
              }
            }
            else {
              swal.fire({ title: "Atenção!", type: "error", text: "As informações não conferem, por favor tente novamente." });
            }
          },
          error => {
            this.Mostrar = false;

            swal.fire({ title: "Atenção!", type: "error", text: "Ocorreu um erro durante a verificação das informações enviadas." });
          }
        )
      }
      else {
        this.markFormGroupTouched(this.formConfirmacaoDadosEleicao);
      }
    }
    else {
      if (this.formVerificaEmail.valid) {
        this.Mostrar = true;

        let codigoCtrl = this.formVerificaEmail.get("codigoVerificacao");

        if (codigoCtrl) {
          this.validarCodigoEleicao(codigoCtrl.value).then((result: any) => {
            this.Mostrar = false;

            if (!result.Valid) {
              let errorMessage = "";

              switch (result.Message) {
                case "NOT_FOUND":
                  errorMessage = "Usuário não foi encontrado.";
                  break;
                case "EXPIRED":
                  errorMessage = "O código informado expirou. Solicite um novo código para continuar.";
                  break;
                case "INVALID":
                  errorMessage = "As informações não conferem, por favor tente novamente.";
                  break;
                case "EXCEEDED":
                  errorMessage = "Número máximo de tentativas excedido. Um novo código deverá ser solicitado.";
                  break;
              }

              if (result.Message == "EXPIRED" || result.Message == "EXCEEDED") {
                swal.fire({
                  title: "Atenção!",
                  text: errorMessage,
                  type: "error",
                  confirmButtonColor: "#009688",
                  showCancelButton: true,
                  confirmButtonText: "Reenviar código",
                  cancelButtonText: "Fechar"
                })
                .then((result) => {
                  if (result.value) {
                    this.reenviarCodigo();
                  }
                });
              }
              else
                swal.fire({ title: "Atenção!", type: "error", html: errorMessage });
            }
            else {
              this.eleicaoVerificouEmail = true;
            }
          }).catch((error) => {
            this.Mostrar = false;
            swal.fire({ title: "Atenção!", type: "error", text: "Ocorreu erro durante a operação." });
          });
        }
      }
      else
        this.markFormGroupTouched(this.formVerificaEmail);
    }
  }

  reenviarCodigo() {
    this.Mostrar = true;

    this.enviarCodigoEleicao(true).then((result) => {
      this.Mostrar = false;
    }).catch((error) => {
      this.Mostrar = false;

      let errorMessage = "Ocorreu erro durante a operação.";

      if (error.status === 404)
        errorMessage = "Não foi encontrado e-mail cadastrado, por favor, entre em contato com o instituto.";

      swal.fire({ title: "Atenção!", type: "error", text: errorMessage });
    });
  }

  inicializaEleicao() {
    this.formConfirmacaoDadosEleicao = this.formBuilder.group({
      nome: [null],
      cpf: [null],
      nomeMae: [null],
      dataNasc: [null],
      telefoneCelular: [null],
      estadoCivil: [null],
      ufNascimento: [null],
      naturalidade: [null]
    });

    this.formVerificaEmail = this.formBuilder.group({
      codigoVerificacao: [null, Validators.required],
    });

    this.formVerificaEmail.reset();
    this.formConfirmacaoDadosEleicao.reset();
  }

  aplicaParametrosEleicao(requiredIds: string[]) {
    this.requiredIds = requiredIds;

    Object.entries(this.eleicaoFieldMap).forEach(([id, field]) => {
      const control = this.formConfirmacaoDadosEleicao.get(field);

      if (requiredIds.includes(id)) {
        control.setValidators([Validators.required]);
      } else {
        control.clearValidators();
        control.setValue(null);
      }

      control.updateValueAndValidity();
    });
  }

  private markFormGroupTouched(formGroup: any) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  isEleicaoFieldVisible(id: string): boolean {
    return this.requiredIds.includes(id);
  }

  SelecionarCandidato(candidato_id: number) {
    if (
      this.candidatoselecionado == null ||
      this.candidatoselecionado == undefined
    ) {
      this.candidatoselecionado = candidato_id;
    } else {
      this.candidatoselecionado = null;
    }
  }

  VotarNoCandidato() {
    if (
      this.candidatoselecionado != null ||
      this.candidatoselecionado != undefined
    ) {
      this.confirmarvoto = true;
    } else {
      swal.fire({
        title: "Atenção!",
        type: "warning",
        text: "Selecione um candidato!",
      });
    }
  }

  CancelarVoto() {
    this.confirmarvoto = false;
    this.candidatoselecionado = null;
  }

  ConfirmarVoto() {
    this.GetValidarVoto();
  }

  AumentarFotoCandidato(candidato_id: number, candidato_nome: string) {
    if (this.fotoid == null || this.fotoid == undefined) {
      this.Nomecandidato = candidato_nome;
      this.fotoid = candidato_id;
    } else {
      this.fotoid = null;
      this.Nomecandidato = null;
    }
  }

  GetValidarVoto(): void {
    this.UtilServico.Get(
      "GetValidarVoto?&id=" +
      this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID +
      "&resposta_id=" +
      this.candidatoselecionado
    ).subscribe(
      (data) => {
        swal.fire({ title: "Obrigado!", type: "success", text: "Seu voto foi computado com sucesso!" }).then(() => {
          this.gerarComprovanteEleicao();
        });

        this.candidatos = [];
        this.eleicoes = [];
        this.candidatoselecionado = null;
        this.confirmarvoto = false;
        this.fotoid = null;
        this.GetEleicoes();
        this.GetEleicoesComComprovante();
      },
      (error) => {
        swal.fire({
          title: "Atenção!",
          type: "warning",
          text: "Não foi possível confirmar seu voto no momento!",
        });
      }
    );
  }

  GetCandidatos(): void {
    this.UtilServico.Get(
      "GetCandidatos/" + this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID
    ).subscribe(
      (data) => {
        this.candidatos = data;
      },
      (error) => { }
    );
  }
  //endregioneleicoes

  //region parametros
  async GetParametros() {
    await this.ValidarNotificacao();
    await this.ValidarNotificacaoCC();
    await this.ValidarNotificacaoRendimento();

    const categoriaId = this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID;
    const isExSegurado = this.UtilDadosLogado.DadosAcesso().EX_SEGURADO == "S";

    this.UtilServico.Get(`GetParametros/?categoriaId=${categoriaId}&isExSegurado=${isExSegurado}`).subscribe(
      (data) => {
        this.parametros = data[0];
        if (this.parametros.PORTAL_OCULTA_OPCAO_FOLHA_PROCESSADA_VAZIA == "S") {
          this.GetInfFinanceiraSegurado(
            this.UtilDadosLogado.DadosAcesso().SEGURADO_ID
          );
        }

        //INICIO DA NOTIFICACAO DO CHAMDO 397880
        var validacc = this.isValidarCC;
        var validarredimento = this.isValidarRedimento;
        var ValidarNotificacao = this.isValidaNotificacao;
        var html1 = "";
        var html = "";

        if (validacc != false) {
          if (data[0].AUTENTICACAO_ATIVA_CC == "S") {
            if (
              ValidarNotificacao[0].TMP_NUMERO_REPETICOES_CC <=
              data[0].NUMERO_REPETICOES_CC
            ) {
              html = data[0].NOTIFICACAO_CONTRACHEQUE;
            }
          }
        }
        if (validarredimento != false) {
          if (data[0].AUTENTICACAO_ATIVA_RENDIMENTO == "S") {
            if (
              ValidarNotificacao[0].TMP_NUMERO_REPETICOES_RENDIMENTO <=
              data[0].NUMERO_REPETICOES_RENDIMENTO
            ) {
              html1 = data[0].NOTIFICACAO_RENDIMENTO;
            }
          }
        }

        if (html != "" || html1 != "") {
          swal.fire({
            title: "Atenção!",
            type: "warning",
            html: html + "<br>" + html1,
          });
        }
      },
      (error) => {
        console.error("Erro", error);
      }
    );
  }

  GetNotPortal(): void { }
  //#endregion parametros
  Recadastramento() {
    localStorage.setItem(
      "AcessoCenso",
      JSON.stringify(
        Object.assign(this.UtilDadosLogado.DadosAcesso(), {
          Parametro: this.parametros.PORTAL_CADASTRO_DIRETO,
        })
      )
    );
    //window.open("http://201.62.46.58/CensoPortal/portal/?PESSOA_ID="+this.UtilDadosLogado.DadosAcesso().PESSOA_ID+"/?CategoriaId="+this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID+"/?SeguradoId="+this.UtilDadosLogado.DadosAcesso().SEGURADO_ID+"/?Parametro="+this.parametros.PORTAL_CADASTRO_DIRETO, "_blank");
    // window.open("http://201.62.44.57/CensoPortal/portal/", "_blank");
    //window.open("http://201.62.46.58/CensoPortal/portal/", "_blank");
    window.open(
      "http://localhost:62768/Portal/?PESSOA_ID=" +
      this.UtilDadosLogado.DadosAcesso().PESSOA_ID +
      "/?CategoriaId=" +
      this.UtilDadosLogado.DadosAcesso().CATEGORIA_ID +
      "/?SeguradoId=" +
      this.UtilDadosLogado.DadosAcesso().SEGURADO_ID +
      "/?Parametro=" +
      this.parametros.PORTAL_CADASTRO_DIRETO,
      "_blank"
    );
    //window.open("http://proxima.sisprevweb.com.br/CensoPortalEs/portal/","_blank");
  }

  logout() {
    localStorage.removeItem("AcessoAdm");
    this.router.navigate(["/login"]);
  }

  //#region Recadastramento
  //#region Boleto Arrecadação

  public BoletoArrecadacao() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetBoletos",
        JSON.stringify({
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        }),
        options
      )
      .map((response: Response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          this.BOLETOS_PORTAL = data;
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }

  EmitirBoletoArrecadacao(PARCELA_ID: any) {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GeraDadosBoleto",
        JSON.stringify({
          PARCELA_ID: PARCELA_ID,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;

          if (this.isTypedArray(data) == true) {
            var file = new Blob([data], { type: "application/pdf" });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            saveAs(file, "BoletoArrecadacao.pdf");
          } else {
            swal.fire({
              title: "Atenção!",
              type: "error",
              text: "Nenhum registo encontrado!",
            });
          }
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum registo encontrado!",
          });
        }
      );
  }

  SetarDadosCendente(DADOS_BOLETO: any) {
    if (DADOS_BOLETO != null && DADOS_BOLETO.length > 0) {
      this.DADOS_CEDENTE_BOLETO.CEDENTE = DADOS_BOLETO.CEDENTE;
      this.DADOS_CEDENTE_BOLETO.COMPETENCIA = DADOS_BOLETO.COMPETENCIA;
      this.DADOS_CEDENTE_BOLETO.FUNDO = DADOS_BOLETO.FORMA_FINANCIAMENTO;
    }
  }

  ParcelaEstaVencida(VENCIMENTO: any) {
    let dataAtual = this.datePipe.transform(new Date(), "dd/MM/yyyy");
    let dataVENCIMENTO = this.datePipe.transform(VENCIMENTO, "dd/MM/yyyy");
    let parcelaVencida = false;

    if (dataAtual < dataVENCIMENTO) {
      parcelaVencida = true;
    }

    return parcelaVencida;
  }

  isTypedArray(obj: any) {
    return obj.type == "application/pdf";
  }

  //#endregion Boleto Arrecadação

  PerguntasFrequentes() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });

    this.http
      .get(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/GetPerguntasFrequentes",
        options
      )
      .map((response: Response) => response.json())
      .subscribe(
        (data) => {
          this.perguntasFrequentes = data;
        },
        (error) => {
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhuma pergunta cadastrada!",
          });
        }
      )
      .add(() => (this.Mostrar = false));
  }

  Informativos() {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });

    this.http
      .get(
        this.UtilDadosLogado.DadosAcesso().URL + "/api/Inicial/GetInformativos",
        options
      )
      .map((response: Response) => response.json())
      .subscribe(
        (data) => {
          this.informativos = data;
          if (!this.informativos || !Array.isArray(this.informativos)) {
            // Se os dados não forem uma matriz válida, defina 'informativos' como uma matriz vazia.
            this.informativos = [];
          }
          this.menssagemLida();
          this.Mostrar = false;
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Nenhum informativo cadastrado!",
          });
        },
      );
  }

  tabela: InformPortal[] = [];

  menssagemLida() {
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    this.tabela = [];
    var locastorages = JSON.stringify(sessionStorage.getItem("AcessoAdm"));

    this.informativos.forEach((x) => {
      this.tabela.push({
        DATA_VISUALIZACAO: x.DATA_VISUALIZACAO,
        INFORME_ID: Number(x.INFORME_ID),
        USR_LOGIN_ID: Number(this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID),
      });
    });

    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/PostNotificarInformativos",
        JSON.stringify(this.tabela),
        options
      )
      .subscribe(
        (result) => console.error(result),
        (error) => console.error(error)
      );
  }

  RecadastramentoOnline() {
    this.UtilServico.Get("Recadastramento").subscribe(
      (data) => {
        this.recadastramentoOnline = data;
        if (this.recadastramentoOnline.length > 0) {
          let mesAtual = new Date().getMonth() + 1;
          let mesAniversario =
            new Date(this.UtilDadosLogado.DadosAcesso().DATA_NASC).getMonth() +
            1;
          this.recadastramentoOnlineExibir =
            this.recadastramentoOnline[0].RECAD_ONLINE_ANIVERSARIO == 1
              ? mesAtual == mesAniversario
              : true;
          this.agendDataIni =
            this.recadastramentoOnline[0].DATA_COMPARECIMENTO_INICIO;
          this.agendDataFim =
            this.recadastramentoOnline[0].DATA_COMPARECIMENTO_FIM;
          this.agendDescricao = this.recadastramentoOnline[0].DESCRICAO;
        } else this.recadastramentoOnlineExibir = false;
      },
      (error) => { }
    );
  }

  ObterDadosPessoais() {
    this.Pessoas();
    this.UtilServico.Post(
      "Dependentes",
      JSON.stringify({
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
      })
    ).subscribe(
      (data) => {
        this.dependentes = data;
      },
      (error) => { }
    );
  }

  AgendarRecadastramento() {
    this.Mostrar = true;
    let body = this.DADOSPESSOAIS;
    this.UtilServico.Put(
      "PutPESSOAS/" + this.DADOSPESSOAIS.PESSOA_ID,
      body
    ).subscribe((data) => { });
    this.UtilServico.Post(
      "AgendarRecadastramento",
      JSON.stringify({
        SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
        PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
        MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
        NOME: this.UtilDadosLogado.DadosAcesso().NOME,
        LOGIN: this.UtilDadosLogado.DadosAcesso().LOGIN,
        DATA_CALC: this.recadastramentoOnlineData,
      })
    ).subscribe(
      (data) => {
        if (data.Codigo == 0) {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: data.Msg,
          });
        } else {
          this.EmitirComprovanteAgendamento(data.Msg);
          this.Mostrar = false;
          swal.fire({
            title: "Obrigado!",
            type: "success",
            text: "Agendamento realizado com sucesso!",
          });
        }
      },
      (error) => {
        swal.fire({
          title: "Atenção!",
          type: "warning",
          text: "Não foi agendar o recadastramento!",
        });
      }
    );
  }

  public EmitirComprovanteAgendamento(protocolo) {
    this.Mostrar = true;
    let headers = new Headers({
      "Content-Type": "application/json; charset=utf-8",
    });
    let options = new RequestOptions({ headers: headers });
    options.responseType = ResponseContentType.Blob;
    this.http
      .post(
        this.UtilDadosLogado.DadosAcesso().URL +
        "/api/Inicial/EmitirComprovanteAgendamento",
        JSON.stringify({
          SEGURADO_ID: this.UtilDadosLogado.DadosAcesso().SEGURADO_ID,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          MAT_ORG: this.UtilDadosLogado.DadosAcesso().MAT_ORG,
          NOME: this.UtilDadosLogado.DadosAcesso().NOME,
          LOGIN: this.UtilDadosLogado.DadosAcesso().LOGIN,
          DATA_CALC: this.recadastramentoOnlineData,
          ESPECIAL: protocolo,
        }),
        options
      )
      .map((response) => response.json())
      .subscribe(
        (data) => {
          this.Mostrar = false;
          var file = new Blob([data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        },
        (error) => {
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: "warning",
            text: "Não foi emitir o comprovante de recadastramento!",
          });
        }
      );
  }

  //#region Solicitar Beneficio
  AssuntoSolicitarBeneficio() {
    this.UtilServico.Get("GetAssuntoSolicitarBeneficio").subscribe(
      (data) => (this.assuntoSolicitacaoBenef = data),
      (error) => { }
    );
  }
  setAssuntoSolicitarBeneficio($event) {
    this.selectedAssuntoSolicitacaoBenefId = $event;
    for (var i = 0; i < this.assuntoSolicitacaoBenef.length; i++) {
      if (this.assuntoSolicitacaoBenef[i].ASSUNTO_ID == $event) {
        this.SOLIC_BENEF.ASSUNTO_ID =
          this.assuntoSolicitacaoBenef[i].ASSUNTO_ID;
        this.selectedAssuntoSolicitacaoBenef =
          this.assuntoSolicitacaoBenef[i].NOME;
      }
    }
  }

  SolicitarBeneficio() {
    if (this.SOLIC_BENEF.ASSUNTO_ID && this.SOLIC_BENEF.DSC) {
      this.Mostrar = true;
      this.UtilServico.Post(
        "GetSolicitarBeneficio",
        JSON.stringify({
          ASSUNTO_ID: this.SOLIC_BENEF.ASSUNTO_ID,
          DATA_ABERTURA: this.SOLIC_BENEF.DATA_ABERT,
          DSC_ASSUNTO: this.SOLIC_BENEF.DSC,
          PESSOA_ID: this.UtilDadosLogado.DadosAcesso().PESSOA_ID,
          USR_LOGIN_ID: this.UtilDadosLogado.DadosAcesso().USR_LOGIN_ID,
        })
      ).subscribe(
        (data) => {
          let mensagemRetorno = data;
          this.Mostrar = false;
          swal.fire({
            title: "Atenção!",
            type: mensagemRetorno.length ? "error" : "success",
            text: mensagemRetorno.length
              ? mensagemRetorno
              : "Sua solicitação foi salva e encaminhada para análise!",
          });
        },
        (error) => {
          this.Mostrar = false;
          console.error(error);
          swal.fire({
            title: "Atenção!",
            type: "error",
            text: "Não foi possível registrar sua solicitação. Favor verificar se as informações estão preenchidas corretamente!",
          });
        }
      );
    } else {
      swal.fire({
        title: "Atenção!",
        type: "error",
        text: "Preencha os campos vazios para continuar.",
      });
    }
  }
  //#endregion Solicitar Beneficio
}



// WEBPACK FOOTER //
// ./src/app/inicial/inicial.component.ts